import {
    MIN_IMG_HEIGHT_ATTRIBUTE,
    DETAILS_VIEW_ATTRIBUTE_IMG,
    DATA_ID_ATTRIBUTE,
} from '@core/constants/ATTRIBUTES';

/**
 * @type {{
 *  ID: string,
 *  PHOTOS: string,
 *  IMAGE: string,
 *  MIN_IMG_HEIGHT: string,
 *  REPORT_TITLE: string,
 *  DATE: string,
 *  TYPE_REPORT: string,
 *  LIGHTBOX: string,
 *  PDF: string,
 *  CURRENT_REPORT_TYPE: string,
 * }}
 * @description Report card attributes.
 */
export const REPORT_CARD_ATTRIBUTES = {
    ID: DATA_ID_ATTRIBUTE,
    PHOTOS: 'photos',
    IMAGE: DETAILS_VIEW_ATTRIBUTE_IMG,
    MIN_IMG_HEIGHT: MIN_IMG_HEIGHT_ATTRIBUTE,
    REPORT_TITLE: 'report-title',
    DATE: 'date',
    TYPE_REPORT: 'type-report',
    LIGHTBOX: 'lightbox',
    PDF: 'pdf',
    CURRENT_REPORT_TYPE: 'current-report-type',
};

/**
 * Wesog report card tag.
 * @type {string} - The wesog report card tag.
 */
export const REPORT_CARD_COMPONENT = 'report-card-component';

/**
 * @type {string}
 * @description - The custom report card loading spinner web component.
 */
export const CUSTOM_REPORT_CARD_LOADING_SPINNER_WEB_COMPONENT =
    '[data-report-card-spinner]';
